"use client";

import { useContext, useEffect, useState } from "react";
import { UserContext } from "@/contexts/user-context";
import { ResourceContext } from "@/contexts/resource-context";
import { logEvent } from "@/service/logs/log";
import { SmsConsentForm } from "@/components/video/sms-consent/components/sms-consent-form/sms-consent-form";
import { canShowSmsConsentModal } from "@/components/video/sms-consent/service";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog";

export const SmsConsent = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { logView } = useContext(ResourceContext);

  const { phoneNumber, smsMarketingConsent, isLoggedIn } =
    useContext(UserContext);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    if (phoneNumber && smsMarketingConsent) {
      return;
    }

    if (canShowSmsConsentModal() && window.innerWidth > 1280) {
      setIsOpenModal(true);
    }
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    if (phoneNumber && smsMarketingConsent) {
      return;
    }

    if (isOpenModal) {
      document.body.style.overflow = "hidden";
      logEvent("webinar_sms_modal_show", logView);
    } else {
      localStorage.setItem(
        "dismissSmsConsent",
        new Date().getTime().toString(),
      );
      logEvent("webinar_sms_modal_dismiss", logView);
      document.body.style.overflow = "auto";
    }
  }, [isOpenModal]);

  if (!isLoggedIn) {
    return;
  }

  if (phoneNumber && smsMarketingConsent) {
    return;
  }

  return (
    <Dialog open={isOpenModal} onOpenChange={setIsOpenModal}>
      <DialogContent
        withScrollbar={true}
        className={
          "flex w-full max-w-[90vw] flex-col items-center justify-center px-4 py-28 sm:max-w-[700px] md:py-12"
        }
      >
        <SmsConsentForm setIsOpenModal={setIsOpenModal} />
        <DialogClose />
      </DialogContent>
    </Dialog>
  );
};
